import { data } from 'jquery';
import { IApiResponse } from 'src/app/shared/interfaces/common-api.interface';
import { CampaignData } from '../../campaign-insight/campaign-insight.interface';

export interface ISchedulerListResponse extends IApiResponse {
  data?: ISchedulerListData;
}

export interface ISchedulerListData {
  page: ISchedulerPage;
  filteredResponse: ISchedulerFilteredData[];
}

export interface ISchedulerPage {
  pageNumber: number;
  totalRecords: number;
  pageSize: number;
  totalPageCount: number;
}

export interface ISchedulerFilteredData {
  campaignCode: string;
  campaignName: string;
  segmentName: string;
  templateCode: string;
  campaignStartDate: string;
  campaignEndDate: string;
  executionStartDate: string;
  executionEndDate: string;
  status: string;
  schedulerCode: string;
  organization: string;
  division: string;
  vertical: string;
  department: string;
  createdBy: string;
  frequency?: string;
  segmentType: string;
  lastExecutedOn?: string;
  schedulerDetail?: any;
  channel: string;
  modeOfExecution: string;
  segmentCode: string;
  wabaCode: string;
  primaryChannel: string;
  secondaryChannel: string;
  linkWaitTime: string;
  channelWaitTime: string;
  urlClickTrack: boolean;
  orchestrationType?: string;
  agentNumber?: string;
  emailSenderId?: string;
  bsp?: string;
  bspSubType?: string;
  wabaNumber?: string;
  emailName?: string;
  budgetExhausted?: boolean;
}

export interface SchedulerListRequest {
  filterType: string;
  filterValue: string;
  pageNumber: number;
  pageSize: number;
}

export enum SchedulerStatus {
  SCHEDULED = 'Scheduled',
  IN_PROGRESS = 'In Progress',
  EXECUTED = 'Executed',
  RESCHEDULED = 'Rescheduled',
  RESCHEDULING_FAILED = 'Rescheduling Failed',
  SCHEDULING_FAILED = 'Scheduling Failed',
  UNSCHEDULING_FAILED = 'Unscheduling Failed',
  FAILED = 'Failed',
  TO_BE_SCHEDULED = 'To Be Scheduled',
  PAUSED = 'Paused',
  CANCELLED = 'Cancelled',
  INVALID_SEGMENT = 'Invalid Segment',
}

export interface ItemConstants {
  label: string;
  key: string;
}

export interface ItemValue {
  primary?: string;
  secondary?: string;
}

export interface Item {
  label: string;
  value: string | string[] | ItemValue;
}

export interface Section {
  items: Item[];
}

export interface FieldsRemoverMapper {
  channelWise: {
    [key: string]: string[];
  };
  modeOfExecution: {
    [key: string]: string[];
  };
}

export interface SchedulerDetailAuditData {
  executionDate: string;
  totalRecord: number;
  passedRecords: number;
  subSegmentCode: string;
}

export interface SchedulerDetails {
  data: {
    totalRecords: string;
    campaignRunCount: number;
    createdBy: string;
    modeOfExecution: string;
    lastExecutedOn: number;
    campaignCode: string;
    campaignName: string;
    segmentName: string;
    campaignStartDate: string;
    campaignEndDate: string;
    status: string;
    executionStartDate: string;
    frequency: string;
    channels: string[];
    cronExpDesc: string;
    executionEndDate: string;
    segmentType: string;
    schedulerDetail: any;
    segmentCode: string;
    orchestrationType: string;
    schedulerCode: string;
    template: {
      channelSequence: number;
      channelName: string;
      templateName: string;
      templateCode: string;
      wabaNumber?: string;
      linkWaitTime?: string;
      channelWaitTime?: string;
      wabaCode?: string;
      agentNumber?: string;
      emailSenderId?: string;
      senderId?: string;
    }[];
    campaignAudit: SchedulerDetailAuditData[];
  };
}

export interface ColumnConfig {
  [key: string]: {
    header?: string;
    sort?: boolean;
    width?: string | number;
    link?: boolean;
    imgsrc?: string;
    path?: string;
    type?: string;
    linkIcon?: boolean;
    url?: string;
    idKey?: string;
    colStyle?: object;
    headerStyle?: object;
    name?: string;
    validRole?: string[];
    filter?: boolean;
    value?: string;
    validPaths?: string[];
    hasColumnFilter?: boolean;
    options?: Array<object | string>;
    optionLabel?: string;
    showMatchModes?: boolean;
    showAddButton?: boolean;
    showOperator?: boolean;
    showApplyButton?: boolean;
    hideOnClear?: boolean;
    filterType?: string;
    flagKey?: string;
    frozen?: boolean;
    isImageVisibleKey?: string;
  };
}

export interface SchedulerFailedQC extends IApiResponse {
  data?: string;
}

export interface ReschedulePopup {
  type: string;
  data:
    | {
        minDate: Date;
        maxDate: Date;
        resumeDate: Date;
        pauseDate?: Date;
        isResumeDisabled?: boolean;
      }
    | { executionDate: string; startTime: Date; segmentType: string };
  rowData?: ISchedulerFilteredData | CampaignData;
}

export interface ClickDetail {
  placeholderName: string;
  count: number;
}

export interface ErrorDetail {
  errorName: string;
  count: number;
  colorClass?: string;
}

export interface ChannelMetrics {
  total?: number;
  passed?: number;
  dnd?: number;
  qc?: number;
  sent: number;
  delivered: number;
  read: number;
  clicks: number;
  clickDetails: ClickDetail[];
  errors: number;
  errorDetails: ErrorDetail[];
  cost: number;
}

export interface ChannelData {
  channel: string;
  channelDetails: ChannelMetrics;
  auditDetails?: AuditDetails;
}

export interface AuditDetails {
  executionDateTime: string;
  total: number;
  passed: number;
  qc: number;
  dnd: number;
}

export interface SubSegmentData {
  subSegmentCode: string;
  executionDateTime?: string;
  subSegmentDetails: ChannelData[];
}

export interface CampaignAnalyticData extends IApiResponse {
  data?: SubSegmentData[];
}

export interface ExecutionData {
  executionDate: string;
  executionDetails: ChannelData[];
}

export interface ApiBasedCampaignAnalyticData extends IApiResponse {
  data?: ExecutionData[];
}

export const apiBasedAnalyticResponse: ApiBasedCampaignAnalyticData = {
  error: false,
  data: [
    {
      executionDate: '24-12-2025',
      executionDetails: [
        {
          channel: 'SMS',
          channelDetails: {
            sent: 10000,
            delivered: 7000,
            read: 500,
            clicks: 900,
            cost: 70,
            qc: 20,
            dnd: 30,
            clickDetails: [
              {
                placeholderName: 'Tiny Url 1',
                count: 100,
              },
              {
                placeholderName: 'Tiny Url 2',
                count: 800,
              },
            ],
            errors: 300,
            errorDetails: [
              {
                errorName: 'Not Reachable',
                count: 100,
              },
              {
                errorName: 'Invalid',
                count: 800,
              },
            ],
          },
        },
        {
          channel: 'WHATSAPP',
          channelDetails: {
            sent: 10000,
            delivered: 7000,
            read: 500,
            clicks: 900,
            cost: 30.12,
            qc: 20,
            dnd: 30,
            clickDetails: [
              {
                placeholderName: 'Tiny Url 1',
                count: 100,
              },
              {
                placeholderName: 'Tiny Url 2',
                count: 800,
              },
            ],
            errors: 300,
            errorDetails: [
              {
                errorName: 'Not Reachable',
                count: 100,
              },
              {
                errorName: 'Invalid',
                count: 800,
              },
            ],
          },
        },
        {
          channel: 'EMAIL',
          channelDetails: {
            sent: 10000,
            delivered: 7000,
            read: 500,
            clicks: 900,
            cost: 30.12,
            qc: 20,
            dnd: 30,
            clickDetails: [
              {
                placeholderName: 'Tiny Url 1',
                count: 100,
              },
              {
                placeholderName: 'Tiny Url 2',
                count: 800,
              },
            ],
            errors: 10,
            errorDetails: [
              {
                errorName: 'Not Reachable',
                count: 5,
              },
              {
                errorName: 'Invalid',
                count: 5,
              },
            ],
          },
        },
      ],
    },
    {
      executionDate: '23-12-2025',
      executionDetails: [
        {
          channel: 'SMS',
          channelDetails: {
            sent: 1000,
            delivered: 700,
            read: 50,
            clicks: 90,
            cost: 7,
            qc: 2,
            dnd: 3,
            clickDetails: [
              {
                placeholderName: 'Tiny Url 1',
                count: 10,
              },
              {
                placeholderName: 'Tiny Url 2',
                count: 80,
              },
            ],
            errors: 30,
            errorDetails: [
              {
                errorName: 'Not Reachable',
                count: 10,
              },
              {
                errorName: 'Invalid',
                count: 80,
              },
            ],
          },
        },
        {
          channel: 'WHATSAPP',
          channelDetails: {
            sent: 10000,
            delivered: 7000,
            read: 500,
            clicks: 900,
            cost: 30.12,
            qc: 20,
            dnd: 30,
            clickDetails: [
              {
                placeholderName: 'Tiny Url 1',
                count: 100,
              },
              {
                placeholderName: 'Tiny Url 2',
                count: 800,
              },
            ],
            errors: 300,
            errorDetails: [
              {
                errorName: 'Not Reachable',
                count: 100,
              },
              {
                errorName: 'Invalid',
                count: 800,
              },
            ],
          },
        },
        {
          channel: 'EMAIL',
          channelDetails: {
            sent: 10000,
            delivered: 7000,
            read: 500,
            clicks: 900,
            cost: 30.12,
            qc: 20,
            dnd: 30,
            clickDetails: [
              {
                placeholderName: 'Tiny Url 1',
                count: 100,
              },
              {
                placeholderName: 'Tiny Url 2',
                count: 800,
              },
            ],
            errors: 10,
            errorDetails: [
              {
                errorName: 'Not Reachable',
                count: 5,
              },
              {
                errorName: 'Invalid',
                count: 5,
              },
            ],
          },
        },
      ],
    },
  ],
};
